import type { RTCSession } from 'jssip/lib/RTCSession';

export function isWavelloSession(session: RTCSession): boolean {
  // Return false (meaning "not Wavello") unless certain.
  const uri = session.remote_identity?.uri?.toString();
  return uri?.includes('SVRS-DHV-') ?? false;
}
